import React, { useState } from "react";
import "./PasswordInput.css";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const PasswordInput = ({
  label,
  value = "",
  name,
  onChange,
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter password",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  maxLength,
  minLength,
  readOnly = false,
  disabled = false,
  required = false,
  pattern = "",
  title,
  autocomplete = "off",
  customError,
  asterisk,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div
      className={`${parentClassName} password-input-container`}
      style={parentStyle}
    >
      <label
        style={labelStyle}
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-password-label-class"
        }
      >
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="password-input-wrapper">
        <input
          type={isPasswordVisible ? "text" : "password"}
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          className={`${
            inputClassName && inputClassName.trim() !== ""
              ? `${inputClassName} inputPadding`
              : "default-password-input-class"
          } ${customError ? "input-error" : ""}`.trim()}
          style={inputStyle}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          pattern={pattern}
          title={title}
          autocomplete={autocomplete}
        />
        <button
          type="button"
          className="toggle-visibility-btn"
          onClick={togglePasswordVisibility}
        >
          {isPasswordVisible ? (
            <i class="fas fa-eye"></i>
          ) : (
            <i class="fas fa-eye-slash"></i>
          )}
        </button>
        {customError && (
          <i className="fas fa-exclamation-circle error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default PasswordInput;
